export const CABIN_TYPE = [
    { id: 1, name: "Economy", value: "economy" },
    { id: 2, name: "Premium Economy", value: "premium_economy" },
    { id: 3, name: "Business", value: "business" },
    { id: 4, name: "Premium Business", value: "premium_business" },
    { id: 5, name: "First", value: "first" },
    { id: 6, name: "Premium First", value: "premium_first" },
];

export const NOTIFICATION_CABIN_TYPE = [
    { id: 1, name: "َAll", value: "all" },
    { id: 2, name: "Economy", value: "economy" },
    { id: 3, name: "Business", value: "business" },
];
